import { render, staticRenderFns } from "./FeedbackStats.vue?vue&type=template&id=51540025&"
import script from "./FeedbackStats.vue?vue&type=script&lang=js&"
export * from "./FeedbackStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports